/* ----------------------------------- */
// Domain import pattern. Please       //
// follow below usage for all reducers //
/* ----------------------------------- */

import initialState from "./initial";
import * as Types from "../actions/types";
import { createReducer } from "redux-immutablejs";
import { fromJS } from "immutable";

const initial = fromJS(initialState.blogs);

const blog = createReducer(initial, {
  [Types.RESULT_GET_BLOG]: (state, action) => 
    state.merge({
        list               : action.payload,
    }),
  [Types.RESULT_GET_BLOG_DETAILS]: (state, action) => 
    state.merge({
        details             : action.payload,
    }),
  [Types.CLEAR_BLOG_DETAILS]: (state, action) => 
    state.merge({
        details             : [],
    }),
  // [Types.RESULT_REMOVE_BLOG]: (state, action) => 
    // state.merge({
    //     details             : [],
    // }),
});

export default blog;
